import { InjectionToken } from '@angular/core';
import type { RemoteConfig as RemoteConfigInstance } from 'firebase/remote-config';

export const RemoteConfig = new InjectionToken<RemoteConfigInstance>(
	'marmon.firebase.remote-config',
);
